import { ILaboGids } from '../Interfaces/ILaboGids';
import { IStaalAfname } from '../Interfaces/IStaalAfname';
import { IWetenschappelijkWerk } from '../Interfaces/IWetenschappelijkWerk';
import _ from 'lodash';
require('isomorphic-fetch');
export class DataService {

    public static async getStaalAfnameData(): Promise<IStaalAfname[]> {
        return fetch('https://imz-labo-web.azurewebsites.net/api/AfnameGids')
            // the JSON body is taken from the response
            .then(res => res.json())
            .then((res: IStaalAfname[]) => {
                res = res.filter(x=>x.Title != null);
                return _.sortBy(res, [item => item.Title.toLocaleLowerCase()]);
                return res;
            })
    }

    public static async getLaboGidsData(): Promise<ILaboGids[]> {
        console.log("in data service - getLaboGidsData")
        return fetch('https://imz-labo-web.azurewebsites.net/api/LaboGids')
            // the JSON body is taken from the response
            .then(res => res.json())
            .then((res: ILaboGids[]) => {
                console.log("result");
                res = res.filter(x=>x.Title != null);
                return _.sortBy(res, [item => item.Title.toLocaleLowerCase()]);
                return res;
            })
    }
    public static async getWetenschappelijkWerkData(): Promise<IWetenschappelijkWerk[]> {
        return fetch('https://imz-labo-web.azurewebsites.net/api/WetenschappelijkWerk')
            // the JSON body is taken from the response
            .then(res => res.json())
            .then((res: IWetenschappelijkWerk[]) => {
                // return _.sortBy(res, [item => item.Jaar]);
                return res;
            })
    }

    public static async getLaboGidsItemById(id: string): Promise<ILaboGids> {
        return fetch('https://imz-labo-web.azurewebsites.net/api/LaboGids/' + id)
            // the JSON body is taken from the response
            .then(res => res.json())
            .then((res: ILaboGids) => {
                return res;
            })
    }

    public static async getStaalAfnameItemById(id: string): Promise<IStaalAfname> {
        return fetch('https://imz-labo-web.azurewebsites.net/api/AfnameGids/' + id)
            // the JSON body is taken from the response
            .then(res => res.json())
            .then((res: IStaalAfname) => {
                return res;
            })
    }
    public static async getWetenschappelijkWerkById(id: string): Promise<IWetenschappelijkWerk> {
        return fetch('https://imz-labo-web.azurewebsites.net/api/WetenschappelijkWerk/' + id)
            // the JSON body is taken from the response
            .then(res => res.json())
            .then((res: IWetenschappelijkWerk) => {
                return res;
            })
    }

}